<template>
  <b-modal
    :id="id"
    centered
    :hide-footer="true"
    :title="$t('Delete') + ' ' + $t('l.e') + ' ' + $t('chargePro')">
    <p>
      {{ $t('chargePro.delete.legend') }}
    </p>

    <div class="d-flex align-items-end justify-content-end mt-4">
      <b-button class="btn-sm mx-2" variant="secondary" @click="deleteOnlyOneCharge">
        {{ $t('chargePro.only.this') }}
      </b-button>
      <b-button class="btn-sm" variant="secondary" @click="deleteAllFromChargeGroup">
        {{ $t('chargePro.chargeGroup') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'ProfessionalChargesDeleteModal',

  props: {
    selectedItem: Object
  },

  data() {
    return {
      id: "charge-delete-modal"
    }
  },

  emits: ['didDeleteItem'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    deleteOnlyOneCharge() {
      let successToastMessage = this.$i18n.t('ChargePro') + ' "' + this.selectedItem.tostring + '" ' + this.$i18n.t('f.deleted')

      api
        .delete(`/chargePro/${this.selectedItem.id}`)
        .then(response => {
          this.$emit('didDeleteItem')
          this.hideModal()
          this.successToast(successToastMessage)
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 4000,
              toaster: 'b-toaster-bottom-right',
              variant: "danger",
              solid: true,
            })
          }
        })
    },

    deleteAllFromChargeGroup() {
      let successToastMessage = this.$i18n.t('chargePro.from.group') + ' "' + this.selectedItem.tostring + '" ' + this.$i18n.t('f.deleted.s')

      api
        .delete(`/chargePro/deleteAllFromChargeGroup/${this.selectedItem.id}`)
        .then(response => {
          this.$emit('didDeleteItem')
          this.hideModal()
          this.$nextTick(() => {
            this.successToast(successToastMessage)
          })
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 4000,
              toaster: 'b-toaster-bottom-right',
              variant: "danger",
              solid: true,
            })
          }
        })
    },

    hideModal() {
      this.$bvModal.hide(this.id)
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/professionalCharges/components/ProfessionalChargesDeleteModal.vue